module.exports = __webpack_public_path__ + "static/logo-5ce961bc49bb57a3fdb230261dfdb38f.png";